import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../styles/Checkout.module.css";

const Checkout: React.FC = () => {
  const [form, setForm] = useState({ name: "", email: "", confirmEmail: "", phone: "" });
  const [cart, setCart] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [alerts, setAlerts] = useState<string[]>([]);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cart`, {
          withCredentials: true,
        });
        setCart(res.data.cart);
      } catch (err) {
        console.error("Failed to fetch cart:", err);
      }
    };
    fetchCart();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.phone) {
      setError("All fields are required.");
      return;
    }
    if (form.email !== form.confirmEmail) {
      setError("Emails do not match.");
      return;
    }
    if (cart.length === 0) {
      setError("Your cart is empty.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccessMessage("");
    setAlerts([]);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/checkout`,
        {
          name: form.name,
          email: form.email,
          phone: form.phone,
        },
        { withCredentials: true }
      );

      const { message, alerts: productionAlerts } = res.data;

      setSuccessMessage(message || "Order placed successfully!");
      if (productionAlerts && productionAlerts.length > 0) {
        setAlerts(productionAlerts);
      }

      // Optionally delay redirect to show alerts to user
      setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    } catch (err: any) {
      console.error(err);
      setError(err.response?.data?.message || "Order failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.checkoutContainer}>
      <h1>Checkout</h1>

      {error && <p className={styles.error}>{error}</p>}
      {successMessage && <p className={styles.success}>{successMessage}</p>}

      {alerts.length > 0 && (
        <div className={styles.alertBox}>
          <h4>Production Notice:</h4>
          <ul>
            {alerts.map((a, i) => (
              <li key={i}>{a}</li>
            ))}
          </ul>
          <p>Your order will include these items once production is complete.</p>
        </div>
      )}

      <input
        name="name"
        placeholder="Full Name"
        value={form.name}
        onChange={handleChange}
      />
      <input
        name="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
      />
      <input
        name="confirmEmail"
        placeholder="Confirm Email"
        value={form.confirmEmail}
        onChange={handleChange}
      />
      <input
        name="phone"
        placeholder="Phone Number"
        value={form.phone}
        onChange={handleChange}
      />

      <button className={styles.checkout} onClick={handleSubmit} disabled={loading}>
        {loading ? "Placing order..." : "Complete Order"}
      </button>
    </div>
  );
};

export default Checkout;
